import React from 'react';
import { Star, Users, Gift } from 'lucide-react';
export function BenefitsBar() {
  return <div className="bg-dark text-white py-4 border-y-4 border-gold" data-id="element-15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-12 text-sm md:text-base font-medium text-center" data-id="element-17">
          <div className="flex items-center gap-2" data-id="element-18">
            <Star className="w-5 h-5 text-gold fill-gold" data-id="element-19" />
            <span data-id="element-20">Calificación de 4.9/5 por lectores reales</span>
          </div>

          <div className="hidden md:block w-1.5 h-1.5 rounded-full bg-white/30" data-id="element-21"></div>

          <div className="flex items-center gap-2" data-id="element-22">
            <Users className="w-5 h-5 text-teal-light" data-id="element-23" />
            <span data-id="element-24">+1.200 personas ya transformaron su día a día</span>
          </div>

          <div className="hidden md:block w-1.5 h-1.5 rounded-full bg-white/30" data-id="element-25"></div>

          <div className="flex items-center gap-2" data-id="element-26">
            <Gift className="w-5 h-5 text-coral-light" data-id="element-27" />
            <span data-id="element-28">Libro Digital Completo + 4 Bonos de Regalo Incluidos</span>
          </div>
        </div>
      </div>
    </div>;
}